module.exports = __webpack_public_path__ + "img/pond-success.abd6333e.png";